// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_BLV","cls2":"ActionNav-cls2_F5i ActionNav-cls1_BLV"};